import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormControl from '@material-ui/core/FormControl'
import Creatable from 'react-select/async-creatable'
import _ from 'lodash'
import axios from "axios"
import { REACT_APP_API, REACT_APP_PERITADOR_API } from '../../common/config'
import memoize from 'memoize-one'
import { BFFAgent } from '../../common/BFFAgent'
import { SelectStyles } from '../common/Dropdown/SelectStyles'
import { debouncePromise } from '../common/Utilities';
import { CATALOGO_ENDPOINT, SALES_ENDPOINT } from 'cfgCommon/endpoints';

const DropdownIndicator = (props) => <i {...props} className="material-icons dropdown-indicator">search</i>;
class NoOptionsMessage extends Component {

  constructor() {
    super()
    this.elemMsg = React.createRef()
  }

  componentDidMount() {
    this.elemMsg.current.parentNode.parentNode.classList.add('customized-noselect');
  }

  componentWillUnmount() {
    this.elemMsg.current.parentNode.parentNode.classList.remove('customized-noselect');
  }

  render() {
    return <div ref={this.elemMsg} id="customized-focus" className="select-search-label select-custom-empty-focus">{this.props.ct}</div>
  }

}
const CreateLabel = (props) => <div className="select-search-label">Agregar {props} a la búsqueda</div>
const LoadingMessage = props => {
  if (!props.selectProps.inputValue || (props.selectProps.inputValue && props.selectProps.inputValue.length < 3)) {
    return <NoOptionsMessage {...props} ct="Ingrese búsqueda..."></NoOptionsMessage>
  } else {
    return <NoOptionsMessage {...props.innerProps} ct="cargando..."></NoOptionsMessage>
  }
}

class FiltroSearch extends Component {
  static propTypes = {
    onChangeSearch: PropTypes.func.isRequired,
    actions: PropTypes.string,
  }
  constructor(props) {
    super(props);

    this.state = {
      inputValue: '',
      values: [],
      menuIsOpen: false,
      keywordLoaded: false
    }
  }

  handleChange = (newValue, actionMeta) => {
    this.setState({values: newValue, inputValue: '', menuIsOpen: false})
    if (actionMeta.action === 'clear' || _.isNull(newValue)) {
      this.setState({values: [], inputValue: '',menuIsOpen: false})
      this.props.onChangeSearch('')
    } else {
        this.props.onChangeSearch(newValue)
    }
  }

  handleChangeSimpleTexfield = (newValue) => {
    this.setState({values: newValue, inputValue: newValue.label, menuIsOpen: false})
    this.props.onChangeSearch(newValue)
  }
  
  handleClean = () => {
    this.setState({values: [], inputValue: '',menuIsOpen: false})
  }

  loadOptions = (inputValue) => {
    if(inputValue.length > 2 && this.props.predictible) {
      switch (this.props.loadOptionsEndPoint) {
        case "clients":
          return axios.get(`${REACT_APP_API}/${this.props.loadOptionsEndPoint}/keywords/${inputValue.trim()}`).then((res) => {
            return res.data.data.map((opcion) => ({ label: opcion.value, value: opcion.value }))
          })
        case "peritador":
          return axios.get(`${REACT_APP_PERITADOR_API}/keywords?key=${inputValue.trim()}`).then((res) => {
            return res.data.map((opcion) => ({ label: opcion.keyword, value: opcion.keyword }))
          })
        case "sales":
          return axios.get(`${SALES_ENDPOINT}/keywords/${inputValue.trim()}`).then((res) => {
            return res.data.data.map((opcion) => ({ label: opcion.value, value: opcion.value }))
          })

        case "dictionary":
          return BFFAgent.Stock.Dictionary.getKeywords(inputValue)
 
        case "catalogs":
          return axios.get(`${CATALOGO_ENDPOINT}/keywords/${inputValue.trim()}`).then((res) => {
            return res.data.data.map((opcion) => ({ label: opcion.value, value: opcion.value }))
          })
        case "campaigns":{
          return BFFAgent.Leads.getCampaigns(inputValue.trim()).then((res) => {
            return res.data?.map((opcion) => ({ label: opcion.value, value: opcion.value }))
          })
        }

        default:
          return;
      }
    }
  }

  debounceLoadOptions = debouncePromise(this.loadOptions, 500);

  handleOnInputChange=(inputValue, {action})=>{
    if(this.props.predictible && !this.state.menuIsOpen) { this.setState({menuIsOpen: true}) }
    // Se valida si se paso por props maxLimitWords, si se paso tambien se valida que no exceda la cantidad de palabras y si no se paso por props
    // que siga con su fincionalidad y no controle la cantidad de palabras
    if (action === 'input-change' && (!(this.props?.maxLimitWords) || this.props?.maxLimitWords > this.state.values.length)) {
      this.setState({ inputValue: this.props.predictible ? inputValue.trim() : inputValue })
    }
  }

  handleOnInputChangeSimpleTexfield = (inputValue, {action}) => {
    if (action === 'input-change') {
      if(this.props.predictible && !this.state.menuIsOpen) this.setState({menuIsOpen: true})
      this.setState({inputValue, values: inputValue ? {label: inputValue, value: inputValue}: '', menuIsOpen: inputValue.length > 2})   
      this.props.onChangeSearch(inputValue ?{label: inputValue, value: inputValue}: '')
    }
  }

  handleOnKeyDown = (event) => {
    const { inputValue, values } = this.state;
    if (!inputValue || this.props?.maxLimitWords <= values.length) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
      case ' ': {
        const checkValue = values.some((item)=>item.label === inputValue.trim())
        if(!this.props.predictible && event.key === ' ' && !this.props.loadOptionsEndPoint == 'clients') return
        if(!checkValue) this.handleChange([...values, {label: inputValue.trim(), value: inputValue.trim()}], 'create-option')
        event.preventDefault()
        return;
      }
      default:
        return;
    }
  };

  getSelectedValues = memoize((string) => {
    const textKey = string?.label || string
    if (textKey) {
      return textKey.split(',').map(key => ({ value: key, label: key }))
    } else {
      return []
    }
  })
  
  componentDidUpdate(pp){
    if (this.props.simpleTextfieldSearch) {
      if(!this.state.keywordLoaded){
        this.setState({values: this.props.keywords, inputValue:this.props.keywords.value , keywordLoaded: true})
      }
    } else {
    if(this.props.keywords && this.state.values.length === 0 && !this.state.keywordLoaded){
      this.setState({values: this.getSelectedValues(this.props.keywords), keywordLoaded: true})
    }
    if(this.props.select !== pp.select) {
      this.setState({values: []})
      this.props.onChangeSearch('')
    }
  }
}

  render() {
    if (this.props.simpleTextfieldSearch) {
      return (
        <div className={'vista-vendedor-filtro-search col'+'p-0'}>
          <FormControl fullWidth variant="outlined">
            <Creatable
              styles={SelectStyles}
              classNamePrefix="customized-filter-box__textfield-search"
              closeMenuOnSelect={false}
              cacheOptions
              menuIsOpen={this.state.menuIsOpen}
              inputValue={this.state.inputValue}
              onInputChange={this.handleOnInputChangeSimpleTexfield}
              NoOptionsMessage
              components={{DropdownIndicator:() => null, indicatorSeperator:() => null, NoOptionsMessage, LoadingMessage}}
              onChange={this.handleChangeSimpleTexfield}
              loadOptions={(e) => this.debounceLoadOptions(e)}
              value={this.state.values}
              placeholder={this.props.placeHolder}
              isValidNewOption={() => false}
              openMenuOnFocus={false} 
              openMenuOnClick={false}
            />
          </FormControl>
        </div>
      )
    }
    else {
      return (
        <div className={"vista-vendedor-filtro-search col "+(this.props.noPadding ? 'pr-0' : 'pr-4 pl-4')}>
          <FormControl fullWidth variant="outlined">
            <Creatable
              styles={SelectStyles}
              classNamePrefix="customized-filter-box"
              closeMenuOnSelect={false}
              isMulti
              cacheOptions
              defaultOptions
              menuIsOpen={this.state.menuIsOpen}
              inputValue={this.state.inputValue}
              onInputChange={this.handleOnInputChange}
              createOptionPosition="first"
              components={{DropdownIndicator, NoOptionsMessage, LoadingMessage}}
              onChange={this.handleChange}
              onKeyDown={this.handleOnKeyDown}
              loadOptions={(e)=> this.debounceLoadOptions(e)}
              value={this.state.values}
              placeholder={this.props.placeHolder}
              formatCreateLabel={CreateLabel}
              isDisabled={this.props?.isLoading ? this.props?.isLoading : false}
            />
          </FormControl>
        </div>
      )
    }
  }
}

FiltroSearch.defaultProps = {
  predictible: true
}

export default FiltroSearch